import { Component, OnInit, ChangeDetectionStrategy, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-dynamic-table-dialog',
    templateUrl: './dynamic-table-dialog.component.html',
    styleUrls: ['./dynamic-table-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicTableDialogComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    tableColumns: string[] = [];
    dataSource: MatTableDataSource<any>;
    listData: any;
    constructor(
        public dialogRef: MatDialogRef<DynamicTableDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { data: { [key: string]: {}; }[], title: string }
    ) { }

    ngOnInit() {
        this.listData = this.data;
        const columnNames = Object.getOwnPropertyNames(this.listData.data[0]);
        columnNames.forEach(element => {
            this.tableColumns.push(element);
        });
        this.dataSource = new MatTableDataSource(this.listData.data);

        this.dataSource.paginator = this.paginator;
        this.sort.sort(({ id: 'name', start: 'asc'}) as MatSortable);
        this.dataSource.sort = this.sort;
        // this.dataSource.filterPredicate = (data: any, filter: string) => this.filterPredicate(data, filter);
        this.applyDataSource(this.listData.data);
        // this.applyDataSourceConfig(this.data.dataSourceConfig);
    }
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    applyDataSource(list: any) {
        this.dataSource.data = list;
    }

    // filterPredicate(data: any, filter: string): boolean {
    //     if (this.data.dataSourceConfig.selectedFilterColumns.length > 0) {
    //         return this.data.dataSourceConfig.selectedFilterColumns.length === 1
    //             ? data[this.data.dataSourceConfig.selectedFilterColumns[0]].toString().toLowerCase().includes(filter.trim().toLowerCase())
    //             : this.data.dataSourceConfig.selectedFilterColumns
    //                 .reduce((prevVal, currVal, idx) => {
    //                     return idx === 1 ? data[prevVal] + data[currVal] : prevVal + data[currVal];
    //                 })
    //                 .toString()
    //                 .toLowerCase()
    //                 .includes(filter.trim().toLowerCase());
    //     }
    // }

    cancel() {
        this.dialogRef.close();
    }
    applyFilter(event: any) {
        this.dataSource.paginator.firstPage();
        this.dataSource.filter = event.trim().toLowerCase();
    }
    sortData(sort: Sort) {
        const isAsc = sort.direction === 'asc';
        const data = this.listData.data.slice();
        if (!sort.active || sort.direction === '') {
          this.dataSource.data = data;
          return;
        }
        this.dataSource.data = data.sort((a, b) => {
            return this.compare(a.active, b.active, isAsc);
        });
    }
    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }
}

